<template>
  <span>
    <slot :name="'item'" :downloadUrl="downloadUrl">
      <a @click.prevent="downLoadFile">
        <i class="fa fa-download" /> <span v-if="showLabel">Download</span>
        <span v-if="currentFile.fileSizeKb">({{ +currentFile.fileSizeKb | fileSize }})</span>
      </a>
    </slot>
  </span>
</template>
<script>
import HTTP from '@/utils/http-common';
function download(url, name) {
  if (!url) {
    throw new Error('Resource URL not provided! You need to provide one');
  }
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const blobURL = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobURL;
      a.style = 'display: none';

      if (name && name.length) a.download = name;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobURL);
    });
}
export default {
  name: 'DownloadFile',
  props: {
    currentFile: {
      type: Object,
      required: true
    },
    showLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    downloadUrl() {
      const { url, fileLocation, fileName } = this.currentFile;
      const name = encodeURIComponent(fileName);
      const location = encodeURIComponent(fileLocation ? fileLocation : url);

      return `${HTTP.defaults.baseURL}/download-file?url=${location}&filename=${name}`;
    }
  },
  methods: {
    downLoadFile() {
      download(this.downloadUrl, this.currentFile.fileName);
    }
  }
};
</script>
